module.exports = __webpack_public_path__ + "img/bornutti33.3401754c.jpg";